import moment from 'moment';
import SkillCertService from "@/service/SkillCertService";
import DatePicker from "vue2-datepicker";
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import { StaffSkillCerts } from "@/model/StaffSkillCerts";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import Settings from '../../../constants/Settings';
export default {
  name: "employeeSkillCerts",
  props: [
    "staffModel", "isSkillCertEditMode", "isSkillCertViewMode"
  ],
  components: {
    DatePicker
  },
  data: () => ({
    skillLocalization: t,
    skillDictEnum: dictEnum,
    skillCertList: [],
    selectedStaffSkillCerts: new StaffSkillCerts(),
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  mounted() {
    this.getAllSkillCertList();
  },
  methods: {
    async getAllSkillCertList() {
      var self = this;
      const obj = {};
      const response = await SkillCertService.getAllSkillCertList(obj);
      if (response.data.IsSuccess) {
        var skillCertList = response.data.Data;
        if (self.isSkillCertViewMode && self.staffModel.StaffSkillCertsList != null && self.staffModel.StaffSkillCertsList.length > 0 && skillCertList != null && skillCertList.length > 0) {
          skillCertList.forEach((element) => {
            element.DateFrom = moment().format(Settings.DateTime.yyyymmdd);
            element.DateTo = moment().format(Settings.DateTime.yyyymmdd);
            if (element.ItemList != null && element.ItemList.length > 0) {
              element.ItemList.forEach((value) => {
                var staffSkillCertDetail = self.staffModel.StaffSkillCertsList.find((obj) => obj.SkillCate == value.SkillCate && obj.Item == value.Item && obj.Seq == value.Seq);
                if (staffSkillCertDetail != null && staffSkillCertDetail != undefined) {
                  if (staffSkillCertDetail.DateFrom != null && staffSkillCertDetail.DateFrom != "") {
                    value.DateFrom = moment(String(staffSkillCertDetail.DateFrom)).format(Settings.DateTime.yyyymmdd);
                  }
                  else {
                    value.DateFrom = '1900-01-01';
                  }
                  if (staffSkillCertDetail.DateTo != null && staffSkillCertDetail.DateTo != "") {
                    value.DateTo = moment(String(staffSkillCertDetail.DateTo)).format(Settings.DateTime.yyyymmdd);
                  }
                  else {
                    value.DateTo = '1900-01-01';
                  }
                  if (value.AnsType != 'CHK') {
                    value.Ans = staffSkillCertDetail.Ans;
                  }
                  else {
                    if (value.OptionCheckboxModelList != null && value.OptionCheckboxModelList.length > 0) {
                      var answerList = [];
                      if (staffSkillCertDetail.Ans.indexOf(',') != -1) {
                        answerList = staffSkillCertDetail.Ans.split(",");
                      }
                      value.OptionCheckboxModelList.forEach((optionCheckbox) => {
                        if (answerList.length > 0) {
                          var answerDetail = answerList.find((obj) => obj == optionCheckbox.Question);
                          if (answerDetail != null && answerDetail != undefined) {
                            optionCheckbox.Answer = true;
                          }
                        }
                        else {
                          if (optionCheckbox.Question == staffSkillCertDetail.Ans) {
                            optionCheckbox.Answer = true;
                          }
                        }
                      });
                    }
                  }
                }
                else {
                  value.DateFrom = moment().format(Settings.DateTime.yyyymmdd);
                  value.DateTo = moment().format(Settings.DateTime.yyyymmdd);
                }
              });
            }
          }
          );
          self.staffModel.SkillCertList = skillCertList;
        }
        else if (skillCertList != null && skillCertList.length > 0) {
          skillCertList.forEach((element) => {
            element.DateFrom = moment().format(Settings.DateTime.yyyymmdd);
            element.DateTo = moment().format(Settings.DateTime.yyyymmdd);
            if (element.ItemList != null && element.ItemList.length > 0) {
              element.ItemList.forEach((value) => {
                value.DateFrom = moment().format(Settings.DateTime.yyyymmdd);
                value.DateTo = moment().format(Settings.DateTime.yyyymmdd);
              });
            }
          }
          );
          self.staffModel.SkillCertList = skillCertList;
        }
        self.skillCertList = skillCertList;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    isNumber: function (evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    downloadFile: function (path) {
      var win = window.open();
      win.document.write('<iframe src="' + path + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
    },
    deleteAttachmentPopup: function (data) {
      var self = this;
      self.selectedStaffSkillCerts = new StaffSkillCerts();
      self.selectedStaffSkillCerts = data;
      $('#deleteAttachmentModal').modal('show');
    },
    OnAttachmentDeleteClick: function () {
      var self = this;
      self.staffModel.StaffAttachmentList.forEach((element, index) => {
        if (element.DocID == self.selectedStaffSkillCerts.DocID) {
          self.staffModel.StaffAttachmentList.splice(index, 1);
          return;
        }
      });
      self.closeAttachmentPopup();
    },
    closeAttachmentPopup: function () {
      var self = this;
      self.selectedStaffSkillCerts = new StaffSkillCerts();
      $('#deleteAttachmentModal').modal('hide');
    },
    changeSkillCertFormDate: function (item) {
      var self = this;
      self.isFromDate = false;
      self.isFromDate = true;
      if (new Date(item.DateFrom) > new Date(item.DateTo)) {
        SweetAlertService.warning("Warn", self.skillLocalization.t(self.skillDictEnum.MSG_DateCompare));
        item.DateFrom = moment().format(Settings.DateTime.yyyymmdd);
        return;
      }
    },
    changeSkillCertToDate: function (item) {
      var self = this;
      self.isToDate = false;
      self.isToDate = true;
      if (new Date(item.DateFrom) > new Date(item.DateTo)) {
        SweetAlertService.warning("Warn", self.skillLocalization.t(self.skillDictEnum.MSG_DateCompare));
        item.DateTo = moment().format(Settings.DateTime.yyyymmdd);
        return;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmployeeSkillCerts.js